module.exports = __webpack_public_path__ + "580733a3c49653a9ae4360636295b885.svg";